/* AWP package protection. Contract v2 (side-session note protection-contract.md).
   Owns the protection line through Shopify's cart AJAX API. Works with or without UpCart. */
(function () {
  var C = window.AWPProtectionConfig;
  if (!C || window.AWPProtection) return;

  var ATTR = '_awp_protection';
  var isUS = C.country === 'US';
  var variantId = isUS ? C.variants.us : C.variants.intl;
  // EU and UK: never offered. The seller carries transit risk there by law (Jared, 2026-10-23).
  var NEVER = 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,DE,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE,GB'.split(',');
  var mode = NEVER.indexOf(C.country) !== -1 ? 'hidden' : ((C.modes && C.modes[C.country]) || 'hidden');
  var countryOk = mode === 'checked' || mode === 'unchecked';
  var defaultOn = mode === 'checked';
  var copy = isUS ? C.copy.us : C.copy.intl;
  var price = isUS ? C.price.us : C.price.intl;

  var nativeFetch = window.fetch.bind(window);
  var cart = null;
  var running = null;
  var again = false;
  var readyResolve;
  var ready = new Promise(function (r) { readyResolve = r; });

  function isProtectionLine(item) {
    return !!item && ((item.sku || '').indexOf('AWP-PROTECT-') === 0 || item.handle === 'package-protection');
  }
  // Redo's old protection line (SKU x-redo, vendor re:do). Jared, 2026-10-24: a shopper never sees two protection lines.
  function isRedoLine(item) {
    return !!item && !isProtectionLine(item) && ((item.sku || '') === 'x-redo' || (item.vendor || '') === 're:do');
  }
  var redoRemovals = 0;
  function hasShippable(c) {
    return c.items.some(function (i) { return !isProtectionLine(i) && i.requires_shipping; });
  }
  function decision(c) {
    return (c && c.attributes && c.attributes[ATTR]) || '';
  }
  function wanted(c) {
    if (!countryOk || !hasShippable(c)) return false;
    var d = decision(c);
    return d === 'accepted' || (d === '' && defaultOn);
  }
  function getState() {
    var on = !!cart && cart.items.some(function (i) { return isProtectionLine(i) && i.variant_id === variantId; });
    return {
      eligible: !!cart && countryOk && hasShippable(cart),
      defaultOn: defaultOn,
      on: on,
      variantId: variantId,
      price: price,
      title: copy.title,
      subtitle: copy.subtitle,
      intro: C.copy.intro,
      noLabel: C.copy.no
    };
  }
  function api(url, body) {
    return nativeFetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('AWP protection: ' + url + ' ' + r.status);
      return r.json();
    });
  }

  // Bring the cart in line with the rules. Returns true when the cart changed.
  function reconcileOnce() {
    return api('/cart.js').then(function (c) {
      cart = c;
      var want = wanted(c);
      var updates = {};
      var keep = null;
      c.items.forEach(function (i) {
        // At most 3 tries per page view, so this can never fight another script.
        if (isRedoLine(i) && redoRemovals < 3) { updates[i.key] = 0; return; }
        if (!isProtectionLine(i)) return;
        if (want && !keep && i.variant_id === variantId) {
          keep = i;
          if (i.quantity !== 1) updates[i.key] = 1;
        } else {
          updates[i.key] = 0;
        }
      });
      var steps = Promise.resolve();
      var changed = false;
      if (Object.keys(updates).length) {
        changed = true;
        if (c.items.some(function (i) { return updates[i.key] === 0 && isRedoLine(i); })) redoRemovals++;
        steps = steps.then(function () { return api('/cart/update.js', { updates: updates }); });
      }
      if (want && !keep) {
        changed = true;
        steps = steps.then(function () {
          return api('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _awp_protection: '1' } }] });
        });
      }
      if (!changed) return false;
      return steps.then(function () { return api('/cart.js'); }).then(function (c2) { cart = c2; return true; });
    });
  }

  function sync() {
    if (running) { again = true; return running; }
    running = reconcileOnce()
      .catch(function (e) { console.warn(e); return false; })
      .then(function (changed) {
        running = null;
        if (again) { again = false; return sync(); }
        if (changed) afterChange();
        emit();
        return cart;
      });
    return running;
  }

  function afterChange() {
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    // When the new cart is the cart page (awpc-page), it redraws itself, so only the theme's own page reloads.
    if (C.isCartPage && !document.documentElement.classList.contains('awpc-page')) window.location.reload();
  }

  function emit() {
    renderMounts();
    document.dispatchEvent(new CustomEvent('awp:protection:changed', { detail: getState() }));
  }

  function set(on) {
    return api('/cart/update.js', { attributes: { _awp_protection: on ? 'accepted' : 'declined' } })
      .then(function (c) { cart = c; return sync(); });
  }

  // Watch other code's cart calls (theme, UpCart, drawer) and re-check afterwards.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 250); }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(schedule, schedule);
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', schedule);
    return xhrOpen.apply(this, arguments);
  };

  // A simple checkbox for any element with data-awp-protection, and for UpCart while it is installed.
  var mounts = [];
  function mount(el) {
    if (!el || el.__awpProt) return;
    el.__awpProt = true;
    mounts.push(el);
    renderInto(el);
  }
  var uid = 0;
  function setText(el, sel, val) {
    var n = el.querySelector(sel);
    if (n && n.textContent !== val) n.textContent = val;
  }
  function renderInto(el) {
    var s = getState();
    if (!s.eligible) { if (el.firstChild) el.innerHTML = ''; return; }
    if (!el.firstChild) {
      var name = 'awp-prot-' + (++uid);
      el.innerHTML =
        '<div class="awp-prot-box" role="radiogroup">' +
        '<div class="awp-prot-box__intro"></div>' +
        '<label class="awp-prot"><input type="radio" value="yes" name="' + name + '">' +
        '<span class="awp-prot__text"><span class="awp-prot__title"></span><span class="awp-prot__sub"></span></span>' +
        '<span class="awp-prot__price"></span></label>' +
        '<label class="awp-prot"><input type="radio" value="no" name="' + name + '">' +
        '<span class="awp-prot__text"><span class="awp-prot__title awp-prot__no"></span></span></label>' +
        '</div>';
      el.querySelectorAll('input').forEach(function (r) {
        r.addEventListener('change', function () {
          var box = el.querySelector('.awp-prot-box');
          box.setAttribute('aria-busy', 'true');
          set(r.value === 'yes').then(function () { box.removeAttribute('aria-busy'); });
        });
      });
    }
    // Only touch text that changed, so observers watching this area don't fire again.
    setText(el, '.awp-prot-box__intro', s.intro);
    setText(el, '.awp-prot__title', s.title);
    setText(el, '.awp-prot__sub', s.subtitle);
    setText(el, '.awp-prot__price', (s.on ? '' : '+ ') + s.price);
    setText(el, '.awp-prot__no', s.noLabel);
    el.querySelector('input[value="yes"]').checked = s.on;
    el.querySelector('input[value="no"]').checked = !s.on;
  }
  function renderMounts() {
    mounts = mounts.filter(function (el) { return el.isConnected; });
    mounts.forEach(renderInto);
  }
  function scanMounts(root) {
    (root || document).querySelectorAll('[data-awp-protection]').forEach(mount);
  }

  function upcartAdapter() {
    var root = window.upcartDocumentOrShadowRoot;
    if (!root || !root.querySelector) return;
    if (!root.querySelector('#awp-prot-upcart-style')) {
      var st = document.createElement('style');
      st.id = 'awp-prot-upcart-style';
      st.textContent =
        '.upcart-product-item:has(a[href*="/products/package-protection"]){display:none!important}' +
        '.awp-prot-box{display:flex;flex-direction:column;gap:8px;padding:8px 0;font-size:14px;line-height:1.35}.awp-prot-box__intro{opacity:.75;font-size:13px}' +
        '.awp-prot{display:flex;gap:10px;align-items:flex-start;padding:10px;border:1px solid rgba(0,0,0,.15);border-radius:6px;cursor:pointer}.awp-prot input{width:18px;height:18px;margin:1px 0 0;flex:none}' +
        '.awp-prot__text{display:flex;flex-direction:column;gap:2px;flex:1}.awp-prot__title{font-weight:700}' +
        '.awp-prot__sub{opacity:.75;font-size:13px}.awp-prot__price{font-weight:700}';
      root.appendChild(st);
    }
    var btn = root.querySelector('.upcart-checkout-button, button[class*="checkout" i]');
    if (btn && !root.querySelector('[data-awp-protection]')) {
      var host = document.createElement('div');
      host.setAttribute('data-awp-protection', 'upcart');
      btn.parentNode.insertBefore(host, btn);
    }
    scanMounts(root);
  }

  function cartPageMount() {
    // On /cart, sit just above the Checkout button.
    var wrap = C.isCartPage && document.querySelector('#CartPageForm .cart__checkout-wrapper');
    if (wrap && !document.querySelector('[data-awp-protection="page"]')) {
      var host = document.createElement('div');
      host.setAttribute('data-awp-protection', 'page');
      wrap.parentNode.insertBefore(host, wrap);
    }
  }

  function boot() {
    cartPageMount();
    scanMounts();
    sync().then(function () { readyResolve(getState()); });
    // Check again once the page settles: right after a country switch the first read can be stale.
    setTimeout(sync, 2000);
    // A page restored by the Back button skips boot, so re-check it too.
    window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
    // UpCart may start after us, so look for it for up to 15 seconds.
    var tries = 0;
    (function findUpcart() {
      var root = window.upcartDocumentOrShadowRoot;
      if (root && root.nodeType) {
        upcartAdapter();
        new MutationObserver(function () { upcartAdapter(); renderMounts(); }).observe(root, { childList: true, subtree: true });
      } else if (++tries < 30) {
        setTimeout(findUpcart, 500);
      }
    })();
    new MutationObserver(function () { scanMounts(); }).observe(document.body, { childList: true, subtree: true });
  }

  window.AWPProtection = {
    ready: ready,
    getState: getState,
    set: set,
    sync: sync,
    mount: mount,
    isProtectionLine: isProtectionLine,
    variants: C.variants
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
